import { Injectable } from '@angular/core';
import { DataService } from '../../../shared/services/data.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { Country } from '../models/country';
import { UserCountry } from '../models/user-country';

@Injectable({
  providedIn: 'root'
})
export class CountryService extends DataService<Country> {

  constructor(http: HttpClient) {
    super(`${environment.apiUrl.authorizationService}countries/`, http);
  }

  getAllCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(`${this.url}AllCountries`);
  }

  getUserCountriesForOrg(): Observable<UserCountry[]> {
    return this.http.get<UserCountry[]>(`${this.url}OrgUserCountries`);
  }

}
